import type { WidgetV2SearchVariant } from '../../layout-variants'
import { getDateRangePickerCss } from '../../date-range-picker'
import commonCss from './common.css?inline'
import horizontalTemplate from './horizontal/template.html?raw'
import boxTemplate from './box/template.html?raw'

export function getSearchTemplate(variant: WidgetV2SearchVariant): string {
  if (variant === 'box') return boxTemplate
  return horizontalTemplate
}

export function getSearchCss(): string {
  return `${commonCss}\n${getDateRangePickerCss()}`
}
